function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.5 25.622c-2.666-2.11-8.697-6.431-15.151-8.008.008 2.879-2.878 6.478-8.744 6.416-5.874-.07-8.666-3.733-8.596-6.611-6.486 1.427-12.618 5.615-15.332 7.662a1.961 1.961 0 00-.447 2.658c1.42 2.102 4.008 5.953 5.639 8.517a1.964 1.964 0 002.964.408 150.325 150.325 0 002.918-2.666l-3.153 11.528a4.675 4.675 0 002.494 5.45c2.572 1.224 6.776 2.51 13.168 2.58 6.399.071 10.634-1.113 13.23-2.281a4.676 4.676 0 002.627-5.38l-2.902-11.82s.934 1.067 2.847 2.91a1.969 1.969 0 002.996-.313c1.686-2.525 4.352-6.306 5.82-8.376a1.955 1.955 0 00-.377-2.674z",
  fill: "#F5F1E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.534 32.774a2.76 2.76 0 100-5.521 2.76 2.76 0 000 5.521z",
  fill: "#5E4537"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.534 27.253a2.76 2.76 0 00-.031 5.521h.031a2.76 2.76 0 00.031-5.521h-.03zm-.086 13.332a2.76 2.76 0 100-5.521 2.76 2.76 0 000 5.521z",
  fill: "#5E4537"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38.448 35.072a2.76 2.76 0 00-.031 5.521h.03a2.76 2.76 0 00.031-5.521h-.03z",
  fill: "#5E4537"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M75.041 70.442c.096-1.904-.836-3.838-2.462-4.996-2.107-1.501-5.026-1.513-7.24-.347a6.668 6.668 0 00-3.448 7.106c.52 2.945 2.933 4.655 6.619 4.62.086-.002.121.108.05.155-2.256 1.492-9.869 1.728-14.801 1.14-8.014-.959-13.998-3.423-14.326-3.56-.566-.239-.513-.533-.209-.969 1.54-2.205 2.968-5.505 3.697-10.042.574-3.568 1.75-8.97 3.465-12.233 1.838-3.5 4.122-5.634 7.664-7.125 3.039-1.278 6.403-1.25 9.38-.492 2.605.662 5.255 2.88 6.228 5.13.114.264.21.303.398-.06 1.932-3.726 3.18-7.996 3.404-10.66.006-.074.037-.137.121-.096 1.477.709 4.135 2.667 5.12 3.685.137.141.14.192.01.324-2.652 2.698-5.242 5.516-6.707 8.143-.177.318.017.39.22.415 2.857.342 5.47 2.079 7.054 4.439 1.662 2.477 2.238 5.57 1.881 8.513-.4 3.314-1.533 5.668-2.906 7.328-1.427 1.724-3.338 2.8-4.282 3.205-.126.054-.187-.068-.11-.167.558-.724 1.1-1.863 1.18-3.456z",
  fill: "#298035"
});

var SvgAppiconCatalog = function SvgAppiconCatalog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconCatalog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-catalog.b6b622cd.svg";
export { ForwardRef as ReactComponent };